import { useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { toaststyle } from "../../Utils/toaststyle";
import { BaseUrl, excelDownloadUrl } from "../../Container/BaseUrl/BaseUrl";
import { Hourglass } from "react-loader-spinner";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineFileDownload, MdFilterAlt } from "react-icons/md";
import { PiFunnelSimpleBold } from "react-icons/pi";
import {
    setSelectedMenu,
    getAvailableAgentList,
    skillsetListApiData,
} from "../../Redux/Actions/actions";
import {
    ButtonGroup,
    Button,
    Stack,
    Pagination,
    Typography,
    Box,
    Drawer,
    TableSortLabel,
} from "@mui/material";
import {
    StyledPaper,
    StyledTableContainer,
    StyledTable,
    StyledTableRow,
    StyledTableCell,
    StyledTableCell2,
    Search,
    SearchIconWrapper,
    StyledInputBase,
    FormControls,
    Selects,
    MenuItems,
    StyledTableHead,
    StyledTableBody,
} from "../../CustomComponent/TableCompoent";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { el } from "date-fns/locale";

const mapStateToProps = (state) => {
    return {
        selectedMenu: state.contactListData.selectedMenu,
        DropDownAgentList: state.contactListData.DropDownAgentList,
        skillsetdata: state.data.skillsetdata,
    };
};

const InboundAndOutbound = (props) => {
    const selectAgentRef = useRef(null);
    const animatedComponents = makeAnimated();
    var someDate = new Date();
    var date = someDate.setDate(someDate.getDate());
    var defaultValue = new Date(date).toISOString().split("T")[0];
    const [fromDateError, setFromDateError] = useState(false);
    const [toDateError, setToDateError] = useState(false);
    const [fromDate, setFromDate] = useState(defaultValue);
    const [toDate, setToDate] = useState(defaultValue);
    const [type, setType] = useState("");
    const [headerType, setHeaderType] = useState("");
    const [selectedAgent, setSelectedAgent] = useState([]);

    const [loadSpinner, setLoadSpinner] = useState("");
    const [consolidatedList, setConsolidatedList] = useState([]);

    const [multiPageVal, setMultiPageVal] = useState(10);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState(0);

    const [isLoadingExcel, setIsLoadingExcel] = useState(false);

    const [order, setOrder] = useState("desc");
    const [orderBy, setOrderBy] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const [searchedValues, setSearchedValues] = useState({});
    const [agentListData, setAgentListData] = useState([]);

    const consolidatedHeaders = ["Agent Extension", "Agent Name", "Inbound Calls Answered", "Inbound Calls Missed", "Inbound Calls Rejected", "Total Inbound Calls", "Inbound Calls Answered %", "Outbound Calls Answered", "Outbound Calls Missed", "Total Outbound Calls", "Total Calls", "Average Handle Time", "Average Speed Of Answer"];
    const consolidatedInboundHeaders = ["Agent Extension", "Agent Name", "Inbound Calls Answered", "Inbound Calls Missed", "Inbound Calls Rejected", "Total Inbound Calls", "Inbound Calls Answered %", "Total Calls", "Average Handle Time", "Average Speed Of Answer"];
    const consolidatedOutboundHeaders = ["Agent Extension", "Agent Name", "Outbound Calls Answered", "Outbound Calls Missed", "Total Outbound Calls", "Total Calls", "Average Handle Time", "Average Speed Of Answer"];

    const filterRef = useRef({
        from_date: fromDate,
        to_date: toDate,
        agentId: selectedAgent.map((agent) => agent.value),
        type: type,
    });

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            fontSize: "13px",
        }),
    };

    const optionsAgent = agentListData && agentListData.map((agent) => ({
        value: agent.CTIagentLoginTerminalId,
        label: agent.username,
    }));

    const handleSelectAgentChange = (selectedOptions) => {
        setSelectedAgent(selectedOptions);
    };

    const handelShowFilter = () => {
        setShowFilter(true);
    };
    const handelCloseFilter = () => {
        setShowFilter(false);
    };

    const consolidatedApi = async (page, multiPageVal) => {
        setLoadSpinner(true);
        await axios
            .post(BaseUrl + "/reports/inboundoutboundperformance",
                {
                    fromdate: filterRef.current.from_date,
                    todate: filterRef.current.to_date,
                    type: filterRef.current.type,
                    agentid: filterRef.current.agentId,
                    // limit: multiPageVal,
                    // offset: page == 1 ? 0 : (page - 1) * multiPageVal,
                },

                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json",
                        tenantid: localStorage.getItem("TenantId"),
                    },
                }
            )
            .then((res) => {
                setLoadSpinner(true);
                if (res.data.status) {
                    setLoadSpinner(false);
                    setConsolidatedList(res.data.data.data);
                    // setPagination(res.data.count);
                } else {
                    setLoadSpinner(false);
                    setConsolidatedList([]);
                    // setPagination(0);
                }
            })
            .catch((error) => {
                setLoadSpinner(false);
                setConsolidatedList([]);
                // setPagination(0);
                console.log(error);
            });
    };

    const consolidatedDownloadExcel = async () => {
        const { from_date, to_date, type } = filterRef.current;

        setIsLoadingExcel(true);
        try {
            const response = await axios.post(
                BaseUrl + "/reports/inboundoutboundperformanceexcel",
                { fromdate: from_date, todate: to_date, type, agentid: filterRef.current.agentId, },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json",
                        tenantId: localStorage.getItem("TenantId"),
                    },
                }
            );

            setIsLoadingExcel(false);

            if (response.data.status) {
                const fileUrl = excelDownloadUrl + "/" + response.data.data.slice(1);

                const fileRes = await axios.get(fileUrl, { responseType: "blob" });
                const blob = new Blob([fileRes.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;

                const customFileName = `Consolidated_Report_${from_date}_to_${to_date}.xlsx`;
                link.setAttribute("download", customFileName);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                toast.success("Consolidated Report Downloaded Successfully", toaststyle);
            } else {
                toast.warn("No Data Found", toaststyle);
            }
        } catch (error) {
            setIsLoadingExcel(false);
            console.error(error);
            toast.error("Failed to download consolidated report", toaststyle);
        }
    };

    const createSortHandler = (property) => () => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleSearchValues = (event, header) => {
        const eventValue = header;
        const removeSpace = eventValue.split(" ").join("");
        setSearchedValues({ ...searchedValues, [removeSpace]: event.target.value });
    };
    const handleBlur = (event, header) => {
        const eventValue = header;
        const removeSpace = eventValue.split(" ").join("");
        const trimmedValue = event.target.value.trim();
        setSearchedValues({ ...searchedValues, [removeSpace]: trimmedValue });
    };

    const handlePaste = (event, header) => {
        const clipboardData = event.clipboardData.getData("Text").trim();
        const eventValue = header;
        const removeSpace = eventValue.split(" ").join("");
        event.preventDefault();
        setSearchedValues({ ...searchedValues, [removeSpace]: clipboardData });
    };

    const getConsolidatedList = consolidatedList || {}
    const filteredData = getConsolidatedList.filter((row) => {
        const normalize = (str) => str ? str.replace(/\s+/g, "").toLowerCase() : "";
        return row;
    });

    const handleChange = async (event, value) => {
        setPage(value);
        await consolidatedApi(value, multiPageVal);
        setSearchedValues({});
    };

    const handleChangeSetPage = async (event) => {
        setMultiPageVal(event.target.value);
        setPage(1);
        await consolidatedApi(1, event.target.value);
        setSearchedValues({});
    };

    const handleSubmit = () => {
        if (!fromDate) {
            setFromDateError(true);
            return;
        } else if (!toDate) {
            setToDateError(true);
            return;
        } else if (moment(fromDate).isAfter(toDate)) {
            setFromDateError(true);
            return;
        } else {
            filterRef.current = {
                from_date: fromDate,
                to_date: toDate,
                agentId: selectedAgent.map((agent) => agent.value),
                type: type,
            };
            setHeaderType(type);
            handelCloseFilter();
            setFromDateError(false);
            setToDateError(false);
            setSearchedValues({});
            setPage(1);
            consolidatedApi(1, multiPageVal);
        }
    };
    const resetButton = () => {
        setFromDate(defaultValue);
        setToDate(defaultValue);
        setType("");
        setHeaderType("");
        setSelectedAgent([]);
        filterRef.current.from_date = defaultValue;
        filterRef.current.to_date = defaultValue;
        filterRef.current.type = "";
        filterRef.current.agentId = [];
        setFromDateError(false);
        setToDateError(false);
        setSearchedValues({});
        setPage(1);
        consolidatedApi(1, multiPageVal);
    };

    const AgentListApi = async () => {
        try {
            const response = await axios.post(BaseUrl + "/reports/userList",
                {
                    offset: 0,
                    limit: 100,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        tenantid: localStorage.getItem("TenantId"),
                    },
                }
            );
            if (response.data.status) {
                setAgentListData(response.data.Data);
            } else {
                setAgentListData([]);
            }
        } catch (error) {
            console.error("AgentListApi error:", error.response?.data || error.message);
        }
    };


    useEffect(() => {
        consolidatedApi(page, multiPageVal);
        AgentListApi();
    }, []);

    return (
        <StyledPaper>
            <div
                className="card Report-card w-100 border-0"
                style={{ height: "100%" }}
            >
                <div
                    className="card-header border-0 d-flex align-items-center justify-content-between px-2"
                    style={{ fontWeight: 600, color: "#1473e6", height: "50px" }}
                >
                    <div
                        className="fw-bold fs-16"
                        style={{
                            textShadow: "1px 0px 0px #c2c2c27d",
                            color: "#0b3363",
                        }}
                    >
                        Consolidated Report
                    </div>

                    <div>
                        <ButtonGroup
                            variant="contained"
                            aria-label="button group"
                            disableElevation
                            size="small"
                            sx={{
                                textTransform: "capitalize",
                            }}
                        >
                            <Button
                                sx={{
                                    textTransform: "capitalize",
                                }}
                                onClick={() => {
                                    props.setSelectedMenu("ReportMenu");
                                }}
                            >
                                <IoIosArrowBack className="me-2" />
                                Back
                            </Button>

                            <Button
                                sx={{
                                    textTransform: "capitalize",
                                }}
                                onClick={consolidatedDownloadExcel}
                            >
                                <MdOutlineFileDownload className="me-2" />
                                {isLoadingExcel ? "Downloading..." : "Download Report"}
                            </Button>

                            <Button
                                sx={{
                                    textTransform: "capitalize",
                                }}
                                onClick={handelShowFilter}
                            >
                                <PiFunnelSimpleBold className="me-2" />
                                Filter
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>

                {/* card-body */}
                <div
                    className="card-body p-1 box-inset"
                    style={{
                        justifyContent: "center",
                        display: "flex",
                        height: "calc(100% - 50px)",
                        flexDirection: "column",
                        gap: "10",
                    }}
                >
                    <StyledTableContainer>
                        <StyledTable aria-label="sticky table" size="small">
                            <StyledTableHead>
                                <StyledTableRow>
                                    {(() => {
                                        let headers = [];
                                        switch (headerType) {
                                            case "both":
                                                headers = consolidatedHeaders;
                                                break;
                                            case "inbound":
                                                headers = consolidatedInboundHeaders;
                                                break;
                                            case "outbound":
                                                headers = consolidatedOutboundHeaders;
                                                break;
                                            default:
                                                headers = consolidatedHeaders;
                                                break;
                                        }
                                        return headers.map((header, index) => (
                                            <StyledTableCell key={index} sx={{ whiteSpace: "nowrap" }}>
                                                {header}
                                                {/* <TableSortLabel
                                                    direction={orderBy === header ? order : "asc"}
                                                    onClick={createSortHandler(header)}
                                                >
                                                    {header}
                                                </TableSortLabel> */}
                                            </StyledTableCell>
                                        ));
                                    })()}
                                </StyledTableRow>
                            </StyledTableHead>


                            <StyledTableBody>
                                {/* {(() => {
                                    let headers = [];
                                    switch (headerType) {
                                        case "both":
                                            headers = consolidatedHeaders;
                                            break;
                                        case "inbound":
                                            headers = consolidatedInboundHeaders;
                                            break;
                                        case "outbound":
                                            headers = consolidatedOutboundHeaders;
                                            break;
                                        default:
                                            headers = consolidatedHeaders;
                                            break;
                                    }
                                    return (
                                        <StyledTableRow>
                                            {headers.map((header, index) => (
                                                <StyledTableCell key={`search-${index}`}>
                                                    {header === "" ? (
                                                        "--"
                                                    ) : (
                                                        <Search>
                                                            <SearchIconWrapper>
                                                                <MdFilterAlt fontSize="small" sx={{ fontSize: "15px" }} />
                                                            </SearchIconWrapper>
                                                            <StyledInputBase
                                                                sx={{ fontSize: "12px" }}
                                                                placeholder={`Search ${header}...`}
                                                                inputProps={{ "aria-label": "search" }}
                                                                value={searchedValues[
                                                                    header.toLowerCase().replace(/\s+/g, "")
                                                                ] || ""}
                                                                onChange={(event) =>
                                                                    handleSearchValues(event, header.toLowerCase())
                                                                }
                                                                onBlur={(event) =>
                                                                    handleBlur(event, header.toLowerCase())
                                                                }
                                                                onPaste={(event) =>
                                                                    handlePaste(event, header.toLowerCase())
                                                                }
                                                            />
                                                        </Search>
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    );
                                })()} */}

                                {loadSpinner ? (
                                    <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                                        <Hourglass
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="hourglass-loading"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            colors={["#2268a0", "#72a1ed"]}
                                        />
                                    </Stack>
                                ) : filteredData.length > 0 ? (
                                    filteredData
                                        .sort((a, b) => {
                                            {
                                                switch (orderBy) {
                                                    case "":
                                                        return order == "asc"
                                                            ? (a.DCC_agent_Name || "").localeCompare(
                                                                b.DCC_agent_Name || ""
                                                            )
                                                            : (b.DCC_agent_Name || "").localeCompare(
                                                                a.DCC_agent_Name || ""
                                                            );
                                                    default:
                                                        break;
                                                }
                                            }
                                        })
                                        .map((item, index) => {
                                            return (
                                                <StyledTableRow key={index} hover role="checkbox">
                                                    {(() => {
                                                        switch (headerType) {
                                                            case "inbound":
                                                                return (
                                                                    <>
                                                                        <StyledTableCell2>
                                                                            {item?.AgentID}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2 sx={{ minWidth: "150px", maxWidth: "200px" }}>
                                                                            {item?.AgentName == "" ? "ALL AGENTS" : item?.AgentName}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Answered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Missed_Abandoned}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Canceled_Rejected}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Inbound_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Answered_Rate_Percent}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.AHT}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Avg_Speed_Of_Answer}
                                                                        </StyledTableCell2>
                                                                    </>
                                                                )
                                                            case "outbound":
                                                                return (
                                                                    <>
                                                                        <StyledTableCell2>
                                                                            {item?.AgentID}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2 sx={{ minWidth: "150px", maxWidth: "200px" }}>
                                                                            {item?.AgentName == "" ? "ALL AGENTS" : item?.AgentName}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Answered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Unanswered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Outbound_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.AHT}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Avg_Speed_Of_Answer}
                                                                        </StyledTableCell2>
                                                                    </>
                                                                )
                                                            default:
                                                                return (
                                                                    <>
                                                                        <StyledTableCell2>
                                                                            {item?.AgentID}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2 sx={{ minWidth: "150px", maxWidth: "200px" }}>
                                                                            {item?.AgentName == "" ? "ALL AGENTS" : item?.AgentName}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Inbound_Answered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Inbound_Missed_Abandoned}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Inbound_Canceled_Rejected}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Inbound_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Inbound_Answered_Rate_Percent}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Outbound_Answered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Outbound_Unanswered}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Outbound_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Total_Calls}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.AHT}
                                                                        </StyledTableCell2>
                                                                        <StyledTableCell2>
                                                                            {item?.Avg_Speed_Of_Answer}
                                                                        </StyledTableCell2>
                                                                    </>
                                                                )
                                                        }
                                                    })()}
                                                </StyledTableRow>
                                            );
                                        })
                                ) : (
                                    <>
                                        {/* // Data unavailable start */}
                                        <Stack
                                            sx={{
                                                position: "absolute",
                                                width: "100%",
                                                height: "calc(100vh - 14rem)",
                                            }}
                                            justifyContent="center"
                                            alignContent="center"
                                        >
                                            <Stack
                                                className="text-muted"
                                                direction="column"
                                                justifyContent="center"
                                                alignContent="center"
                                            >
                                                <span className="mx-auto">
                                                    <img
                                                        src={Nodata}
                                                        alt="pic"
                                                        style={{ width: "11rem", userSelect: "none" }}
                                                    />
                                                </span>
                                                <span className="mx-auto">
                                                    <h6
                                                        className="text-muted mt-3"
                                                        style={{ fontSize: "13px" }}
                                                    >
                                                        Data unavailable
                                                    </h6>
                                                </span>
                                            </Stack>
                                        </Stack>
                                        {/* // Data unavailable end */}
                                    </>
                                )}
                            </StyledTableBody>
                        </StyledTable>
                    </StyledTableContainer>

                    {/* card-footer */}
                    {/* <div
                        className="card-footer border-0"
                        style={{ padding: "8px 8px 0px 8px" }}
                    >
                        <Stack
                            sx={{ width: "100%", height: "100%" }}
                            direction={"row"}
                            alignItems={"center"}
                            justifyContent={"space-around"}
                        >
                            <Typography
                                sx={{ textTransform: "capitalize", fontSize: "12px" }}
                            >
                                {`Showing ${Math.min(
                                    (page - 1) * multiPageVal + 1,
                                    isNaN(pagination) ? 0 : pagination
                                )} to ${Math.min(
                                    page * multiPageVal,
                                    isNaN(pagination) ? 0 : pagination
                                )} of ${isNaN(pagination) ? 0 : pagination} entries`}
                            </Typography>

                            <Stack direction={"row"} alignItems={"center"}>
                                <Typography
                                    sx={{ textTransform: "capitalize", fontSize: "12px" }}
                                >
                                    Set page
                                </Typography>
                                <FormControls className="ms-1" size="small">
                                    <Selects
                                        labelId="demo-select-small-label"
                                        id="demo-select-small"
                                        label="multiPageVal"
                                        value={multiPageVal}
                                        onChange={handleChangeSetPage}
                                    >
                                        <MenuItems value={10}>10</MenuItems>
                                        <MenuItems value={20}>20</MenuItems>
                                        <MenuItems value={50}>50</MenuItems>
                                        <MenuItems value={100}>100</MenuItems>
                                        <MenuItems value={500}>500</MenuItems>
                                    </Selects>
                                </FormControls>
                            </Stack>

                            <Pagination
                                count={Math.ceil(pagination / multiPageVal)}
                                page={page}
                                variant="outlined"
                                shape="rounded"
                                color="primary"
                                size="small"
                                style={{ float: "right" }}
                                onChange={handleChange}
                            />
                        </Stack>
                    </div> */}
                </div>
            </div>

            {/* Filters Drawer Start  */}
            <Drawer
                anchor="right"
                open={showFilter}
                onClose={() => setShowFilter(false)}
            >
                <Box style={{ width: "20rem" }}>
                    {/* Drawer head start */}
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        className="p-3 shadowDrawer"
                    >
                        <Typography gutterBottom className="drawer-title">
                            Filters
                        </Typography>
                    </Stack>
                    {/* Drawer head end */}

                    {/* Drawer Content start */}
                    <Stack
                        className="p-3"
                        style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
                    >
                        <form className="fs-13">
                            <div className="mb-3 d-flex flex-column text-start">
                                <label htmlFor="exampleInputfromdate" className="form-label">
                                    From Date <small className="text-danger">*</small>
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-lg"
                                    id="exampleInputfromdate"
                                    value={fromDate}
                                    max={defaultValue}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                                {fromDateError && moment(fromDate).isAfter(toDate) && (
                                    <span
                                        className="text-danger mt-2"
                                        style={{ fontSize: "10px" }}
                                    >
                                        From date should be less than To date
                                    </span>
                                )}
                                {fromDateError &&
                                    !moment(fromDate).isAfter(toDate) &&
                                    !fromDate && (
                                        <span
                                            className="text-danger mt-2"
                                            style={{ fontSize: "10px" }}
                                        >
                                            From date is required
                                        </span>
                                    )}
                            </div>
                            <div className="mb-3 d-flex flex-column text-start">
                                <label htmlFor="exampleInputtodate" className="form-label">
                                    To Date <small className="text-danger">*</small>
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-lg"
                                    id="exampleInputtodate"
                                    value={toDate}
                                    max={defaultValue}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                                {toDateError &&
                                    !moment(defaultValue).isBefore(toDate) &&
                                    !toDate && (
                                        <span
                                            className="text-danger mt-2"
                                            style={{ fontSize: "10px" }}
                                        >
                                            To date is required
                                        </span>
                                    )}
                            </div>
                            <div className="mb-3">
                                <label for="exampleInputfromdate" className="form-label">
                                    Agent <small className="text-danger">*</small>
                                </label>
                                <Select
                                    ref={selectAgentRef}
                                    closeMenuOnSelect={true}
                                    components={animatedComponents}
                                    isMulti
                                    options={optionsAgent}
                                    placeholder="Select Agent"
                                    styles={customStyles}
                                    onChange={handleSelectAgentChange}
                                    defaultValue={selectedAgent}
                                />
                            </div>
                            <div className="mb-3 d-flex flex-column text-start">
                                <label htmlFor="exampleInputagent" className="form-label">
                                    Direction <small className="text-danger">*</small>
                                </label>
                                <select
                                    className="form-select"
                                    onChange={(e) => setType(e.target.value)}
                                    value={type}
                                >
                                    <option value="">Select Direction</option>
                                    <option value="inbound">Inbound</option>
                                    <option value="outbound">Outbound</option>
                                    <option value="both">Both</option>
                                </select>
                            </div>
                        </form>
                    </Stack>
                    {/* Drawer Content end */}

                    {/* Drawer footer start */}
                    <Stack
                        className="p-2"
                        sx={{
                            position: "absolute",
                            bottom: "0",
                            background: "#f9f9f9",
                            width: "100%",
                            boxShadow:
                                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
                        }}
                        direction="row"
                        justifyContent="space-between"
                        alignContent="center"
                    >
                        <Button
                            variant="contained"
                            className="me-2 w-100"
                            sx={{
                                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                                textTransform: "Capitalize",
                            }}
                            color="error"
                            disableElevation
                            onClick={handelCloseFilter}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            className="me-2 w-100"
                            sx={{
                                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                                textTransform: "Capitalize",
                            }}
                            color="warning"
                            disableElevation
                            onClick={resetButton}
                        >
                            Reset
                        </Button>
                        <Button
                            className="w-100"
                            variant="contained"
                            disableElevation
                            sx={{
                                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                                textTransform: "Capitalize",
                            }}
                            id="session_filter_Submit"
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                    </Stack>
                    {/* Drawer footer end */}
                </Box>
            </Drawer>
            {/* Filters Drawer end  */}
        </StyledPaper>
    )
}

export default connect(mapStateToProps, {
    setSelectedMenu,
    getAvailableAgentList,
    skillsetListApiData,
})(InboundAndOutbound);